/*
 * 接口统一集成模块
 */
import * as login from './modules/login'
import * as user from './modules/user'
import * as dept from './modules/dept'
import * as role from './modules/role'
import * as menu from './modules/menu'
import * as dict from './modules/dict'
import * as config from './modules/config'
import * as log from './modules/log'
import * as loginlog from './modules/loginlog'
import * as cache from './modules/cache'
import * as category from './modules/cms/category'
import * as content from './modules/cms/content'
import * as file from "./modules/file/file"
import * as banner from "./modules/banner/banner"
import * as student from './modules/student/student'
import * as order from './modules/order'
import * as paylog from './modules/paylog'
import * as refund from './modules/refund'
import * as classrecord from './modules/classrecord/classrecord'
import * as coach from './modules/coach/coach'
import * as school from './modules/school/school'
import * as region from './modules/region/region'
import * as device from './modules/device/device'
import * as examiner from './modules/examiner/examiner'
import * as security from './modules/security/security'
import * as graduation from './modules/graduation/graduation'
import * as stage from './modules/stage/stage'
import * as trainCar from './modules/traincar/traincar'
import * as tag from './modules/tag/tag'
import * as district from './modules/district/district'
import * as studytimeset from './modules/studytimeset/studytimeset'
import * as locationcar from './modules/locationcar/locationcar'
import * as stuCard from './modules/stucard/stucard'
import * as period from './modules/period/period'
import * as imageupload from './modules/image/imageupload'
import * as stusign from './modules/stusign/stusign'
import * as platlog from './modules/platlog/platlog'
import * as resource from './modules/resource';
import * as merchant from './modules/merchant';
import * as price from './modules/price';
import * as subaccount from './modules/sub-account';
import * as financial from './modules/financial';
import * as training from './modules/training';
import * as statisticsOrder from './modules/statistics/order';

// 默认全部导出
export default { resource, login, user, dept, role, menu, dict, config, log, loginlog, cache, category, content, file, banner, student,
  order, paylog, refund, classrecord, coach, examiner, security, device, region, school, graduation, trainCar, stage, tag, district,
  studytimeset, locationcar, stuCard, period, imageupload, stusign, platlog, merchant, price, subaccount, financial, training, 
  statisticsOrder, 
}



// WEBPACK FOOTER //
// ./src/http/api.js